import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function TwShowMore(props) {
  const { t } = useTranslation();
  const { children, preview, showLabel = t("common.showMore"), hideLabel = t("common.showLess") } = props
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <div className="text-gray-800">
      {/* <div>{preview}</div> */}

      {isExpanded === true ? (
        <div className="">
          {children}
        </div>
      ) : (<div className="line-clamp-2">
        {children}
      </div>)}

      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="mt-1 text-secondary hover:underline text-sm font-medium"
      >
        {isExpanded ? hideLabel : showLabel}
      </button>
    </div>
  );
}
